// removed by extract-text-webpack-plugin
module.exports = {"select":"_2ItS2G2Y3UJv_LeeU_887h"};


//////////////////
// WEBPACK FOOTER
// ./components/Evoucher/style.less
// module id = 284
// module chunks = 0